module.exports = __webpack_public_path__ + "img/apple.0aa95c5a.png";